import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(879);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 879);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="sticky top-0 z-50 w-full bg-[#16a34a] text-black py-1 text-center font-black text-[10px] md:text-xs shadow-md uppercase tracking-widest" data-id="element-3">
      🔥 OFERTA DISPONIBLE POR TIEMPO LIMITADO 🔥
    </div>;
}